import { PERMISSION_OPTIONS } from './space.constants';

/** Available permission level options for folder dropdown (re-export from space). */
export const FOLDER_PERMISSION_OPTIONS = PERMISSION_OPTIONS;
